import { defineComponent as _defineComponent } from 'vue'
import AudioPlayer from '@/components/AudioPlayer.vue'
  import type { Author } from '@/services/interfaces/Common'
  import type { PropType } from 'vue'
  import useIcons from '@/composables/useIcons'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useBreakpoint from '@/composables/useBreakpoint'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AuthorAudioSection',
  props: {
    audioSource: {
      type: String,
      required: true,
    },
    audioAuthor: {
      type: Object as PropType<Author | null>,
      default: null,
    },
  },
  setup(__props) {

  const { cornerLeftDown, headphones } = useIcons()
  const { isMobileDevice } = useBreakpoint()

  

return { __sfc: true,cornerLeftDown, headphones, isMobileDevice, AudioPlayer, useIcons, SVGRenderer, useBreakpoint }
}

})